export default __webpack_public_path__ + "static/media/skovstykket-townhouse-5-rooms-12.45148cdd.jpg";